(function() {
  // Developer diagnostics, off by default: run localStorage.setItem('ccDebug', '1') to turn them on.
  // Log ids and states only, never blend contents (recipe, story, answers).
  if (!window.ccDebug) {
    window.ccDebug = function () {
      try {
        if (localStorage.getItem('ccDebug') === '1') console.debug('[CandleCraft]', ...arguments);
      } catch (e) {}
    };
  }

  if (window.logErrorToAzure) return; // Prevent double-init / const redeclaration on re-load

  const DEFAULT_API_BASE = 'https://api.candlecraftcollective.com';
  const API_BASE = String(window.CANDLECRAFT_API_BASE || DEFAULT_API_BASE).replace(/\/+$/, '');
  window.CANDLECRAFT_API_BASE = API_BASE;

  function logErrorToAzure({
    message,
    stack = "",
    url = window.location.href,
    userAgent = navigator.userAgent,
    severity = "error",
    timestamp = new Date().toISOString(),
    functionName = "scentQuiz",
    payload = {},
    openaiError = {},
    userId = "",
    sessionId = ""
  }) {
    fetch(`${API_BASE}/api/logError`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message,
        stack,
        url,
        userAgent,
        severity,
        timestamp,
        function: functionName,
        payload,
        openaiError,
        userId,
        sessionId
      })
    }).catch(err => {
      // Optionally log locally if Azure fails
      console.warn("Failed to log error to Azure:", err);
    });
  }

  window.logErrorToAzure = logErrorToAzure;
})();
